const LayoutDefault = () =>
  import(/* webpackChunkName: "admin-kasir" */ '@/layouts/LayoutDefault.vue');
const LayoutData = () =>
  import(/* webpackChunkName: "admin-kasir" */ '@/layouts/LayoutData.vue');
const Dashboard = () =>
  import(/* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/Index.vue');
const Data = () =>
  import(/* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/Data.vue');
// Faktur Penjualan Pusat ke Stockist
const FakturPenjualanPusat = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/pembayaran/faktur-penjualan-pusat/Index.vue'
  );
const DetailPembayaran = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/pembayaran/faktur-penjualan-pusat/DetailPembayaran.vue'
  );
const DetailPenjualan = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/pembayaran/faktur-penjualan-pusat/DetailPenjualan.vue'
  );

// Laporan
const Laporan = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/Index.vue'
  );
const TambahLaporan = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/TambahLaporan.vue'
  );
const LaporanRestock = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/restock/index.vue'
  );
const TambahLaporanRestock = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/restock/Tambah.vue'
  );
const LaporanPembayaranHarian = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/LaporanPembayaranHarian.vue'
  );
const LaporanKeuanganStockistGlobal = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/laporan-keuangan-stockist/LaporanKeuanganGlobal.vue'
  );
const LaporanKeuanganStockistPerStockist = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/laporan-keuangan-stockist/LaporanKeuanganPerStockist.vue'
  );
const LaporanKeuanganScGlobal = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/laporan-keuangan-sc/LaporanKeuanganGlobal.vue'
  );
const LaporanKeuanganScPerSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/laporan-keuangan-sc/LaporanKeuanganPerSc.vue'
  );
const LaporanGL = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/LaporanGL.vue'
  );
const LaporanOmzetSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/LaporanOmzetSc.vue'
  );
const LogPembayaran = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/laporan/LogPembayaran.vue'
  );

// Validasi Laporan Penjualan
const LaporanPenjualanSC = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/validasi/laporan-penjualan-sc/Index.vue'
  );
const LaporanPenjualanKP = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/validasi/laporan-penjualan-kp/Index.vue'
  );
const LaporanPenjualanPbs = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/validasi/laporan-penjualan-pbs/Index.vue'
  );

const TopupStockist = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/topup/stockist/Index.vue'
  );
const TambahTopupStockist = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/topup/stockist/Tambah.vue'
  );
const TopupSaldoRestockSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/topup/saldo-restock-sc/Index.vue'
  );
const TambahTopupSaldoRestockSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/topup/saldo-restock-sc/Tambah.vue'
  );
const TopupSaldoSisaPembayaranSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/topup/saldo-sisa-pembayaran-sc/Index.vue'
  );
const TambahTopupSaldoSisaPembayaranSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/topup/saldo-sisa-pembayaran-sc/Tambah.vue'
  );
const TarikSaldoDepositSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/tarik/saldo-deposit-sc/Index.vue'
  );
const TambahTarikSaldoDepositSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/tarik/saldo-deposit-sc/Tambah.vue'
  );
const TarikSaldoSisaPembayaranSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/tarik/saldo-sisa-pembayaran-sc/Index.vue'
  );
const TambahTarikSaldoSisaPembayaranSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/tarik/saldo-sisa-pembayaran-sc/Tambah.vue'
  );
const PembayaranTopupSaldoDepositSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/pembayaran/PembayaranTopupSaldoDepositSc.vue'
  );
const PinjamanBarangSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/pembayaran/pinjaman-barang-sc/Index.vue'
  );
const PembayaranPinjamanBarangSc = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/pembayaran/pinjaman-barang-sc/Bayar.vue'
  );
const CekFaktur = () =>
  import(
    /* webpackChunkName: "admin" */ '@/views/CekFaktur.vue'
  );
const MigrasiKurangBayar = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/pembayaran/migrasi-kurang-bayar/Index.vue'
  );
const MigrasiKurangBayarDetail = () =>
  import(
    /* webpackChunkName: "admin-kasir" */ '@/views/pusat/kasir/pembayaran/migrasi-kurang-bayar/Bayar.vue'
  );

let root = '/kasir';

export default [
  {
    path: root + '/',
    component: Dashboard,
    meta: {
      auth: true,
      title: 'Dashboard | Kasir',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/cek-faktur',
    component: CekFaktur,
    meta: {
      auth: true,
      title: 'Cek Faktur',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/data',
    component: Data,
    meta: {
      auth: true,
      title: 'Data Page | Kasir',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/validasi/',
    component: LayoutData,
    children: [
      {
        path: 'laporan-kasir-sc',
        component: LaporanPenjualanSC,
        meta: {
          auth: true,
          title: 'Laporan Penjualan SC | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Validasi Laporan Penjualan SC',
        },
      },
      {
        path: 'laporan-kasir-kp',
        component: LaporanPenjualanKP,
        meta: {
          auth: true,
          title: 'Laporan Penjualan KP | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Validasi Laporan Penjualan KP',
        },
      },
      {
        path: 'laporan-penjualan-pbs',
        component: LaporanPenjualanPbs,
        meta: {
          auth: true,
          title: 'Laporan Penjualan P3S | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Validasi Laporan Penjualan P3S',
        },
      },
    ],
  },
  {
    path: root + '/pembayaran/',
    component: LayoutData,
    children: [
      {
        path: 'faktur-penjualan-pusat-ke-stockist/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Faktur Penjualan ke Stockist',
        },
        children: [
          {
            path: '',
            component: FakturPenjualanPusat,
            name: 'pembayaran.ke-stockist',
            meta: {
              auth: true,
              title: 'Faktur Penjualan ke Stockist | Kasir',
              layout: LayoutDefault,
            },
          },
          {
            path: ':id',
            component: DetailPenjualan,
            name: 'pembayaran.ke-stockist.detail',
            meta: {
              auth: true,
              breadcrumb: 'Detail Faktur Penjualan Pusat ke Stockist',
              title: 'Detail Faktur Penjualan Pusat ke Stockist | Kasir',
              layout: LayoutDefault,
            },
          },
          {
            path: ':id/faktur-pembayaran/:id_pembayaran',
            component: DetailPembayaran,
            meta: {
              auth: true,
              title: 'Detail Faktur Pembayaran | Kasir',
              layout: LayoutDefault,
              breadcrumb: 'Detail Faktur Pembayaran',
            },
          },
        ],
      },
      {
        path: 'topup-saldo-deposit-sc',
        component: PembayaranTopupSaldoDepositSc,
        meta: {
          auth: true,
          title: 'Pembayaran Top Up Saldo Deposit SC | Kasir',
          layout: LayoutDefault,
          breadcrumb: 'Pembayaran Top Up Saldo Deposit SC',
        },
      },
      {
        path: 'pinjaman-barang-sc/',
        component: LayoutData,
        meta: {
          breadcrumb: 'Pembayaran Pinjaman Barang SC',
        },
        children: [
          {
            path: '',
            component: PinjamanBarangSc,
            name: 'pembayaran.pinjaman-barang-sc',
            meta: {
              auth: true,
              title: 'Pembayaran Pinjaman Barang SC | Kasir',
              layout: LayoutDefault,
            },
          },
          {
            path: ':id',
            component: PembayaranPinjamanBarangSc,
            name: 'pembayaran.bayar-pinjaman-barang-sc',
            meta: {
              auth: true,
              breadcrumb: 'Pembayaran Pinjaman Barang SC',
              title: 'Pembayaran Pinjaman Barang SC | Kasir',
              layout: LayoutDefault,
            },
          },
        ],
      },
      {
        path: 'migrasi-saldo-kurang-bayar-stockist',
        component: LayoutData,
        meta: {
          breadcrumb: 'Migrasi Kurang Bayar Stockist',
        },
        children: [
          {
            path: '',
            name: 'migrasi-saldo-kurang-bayar-stockist.index',
            component: MigrasiKurangBayar,
            meta: {
              auth: true,
              title: 'Migrasi Kurang Bayar Stockist',
              layout: LayoutDefault,
            },
            props: {
              trxType: 'topup_stockist_debt'
            }
          },
          {
            path: ':id',
            name: 'migrasi-saldo-kurang-bayar-stockist.detail',
            component: MigrasiKurangBayarDetail,
            meta: {
              auth: true,
              title: 'Pembayaran Migrasi Kurang Bayar Stockist',
              layout: LayoutDefault,
            },
            props: {
              trxType: 'topup_stockist_debt'
            }
          },
        ],
      },
      {
        path: 'migrasi-saldo-kurang-bayar-sc',
        component: LayoutData,
        meta: {
          breadcrumb: 'Migrasi Kurang Bayar SC',
        },
        children: [
          {
            path: '',
            name: 'migrasi-saldo-kurang-bayar-sc.index',
            component: MigrasiKurangBayar,
            meta: {
              auth: true,
              title: 'Migrasi Kurang Bayar SC',
              layout: LayoutDefault,
            },
            props: {
              trxType: 'import_debt_balance'
            }
          },
          {
            path: ':id',
            name: 'migrasi-saldo-kurang-bayar-sc.detail',
            component: MigrasiKurangBayarDetail,
            meta: {
              auth: true,
              title: 'Pembayaran Migrasi Kurang Bayar SC',
              layout: LayoutDefault,
            },
            props: {
              trxType: 'import_debt_balance'
            }
          },
        ],
      },
    ],
  },
  {
    path: root + '/laporan-harian',
    component: LaporanPembayaranHarian,
    meta: {
      auth: true,
      title: 'Laporan Pembayaran Harian | Kasir',
      layout: LayoutDefault,
      breadcrumb: 'Laporan Pembayaran Harian',
    },
  },
  {
    path: root + '/laporan-keuangan-stockist',
    component: LayoutData,
    meta: {
      auth: true,
      title: 'Laporan Keuangan Stockist | Kasir',
      layout: LayoutDefault,
      breadcrumb: 'Laporan Keuangan Stockist',
    },
    children: [
      {
        path: 'laporan-keuangan-global',
        component: LaporanKeuanganStockistGlobal,
        meta: {
          auth: true,
          title: 'Laporan Keuangan Global | Kasir',
          layout: LayoutDefault,
          breadcrumb: 'Laporan Keuangan Global',
        },
      },
      {
        path: 'laporan-keuangan-per-stockist',
        component: LaporanKeuanganStockistPerStockist,
        meta: {
          auth: true,
          title: 'Laporan Keuangan Per Stockist | Kasir',
          layout: LayoutDefault,
          breadcrumb: 'Laporan Keuangan Per Stockist',
        },
      },
    ],
  },
  {
    path: root + '/laporan-keuangan-sc',
    component: LayoutData,
    meta: {
      auth: true,
      title: 'Laporan Keuangan Stockist Center | Kasir',
      layout: LayoutDefault,
      breadcrumb: 'Laporan Keuangan Stockist Center',
    },
    children: [
      {
        path: 'laporan-keuangan-global',
        component: LaporanKeuanganScGlobal,
        meta: {
          auth: true,
          title: 'Laporan Keuangan Global | Kasir',
          layout: LayoutDefault,
          breadcrumb: 'Laporan Keuangan Global',
        },
      },
      {
        path: 'laporan-keuangan-per-sc',
        component: LaporanKeuanganScPerSc,
        meta: {
          auth: true,
          title: 'Laporan Keuangan Per Stockist Center | Kasir',
          layout: LayoutDefault,
          breadcrumb: 'Laporan Keuangan Per Stockist Center',
        },
      },
    ],
  },
  {
    path: root + '/laporan-gl',
    component: LaporanGL,
    meta: {
      auth: true,
      title: 'Laporan GL | Kasir',
      layout: LayoutDefault,
      breadcrumb: 'Laporan GL',
    },
  },
  {
    path: root + '/laporan-omzet-sc',
    component: LaporanOmzetSc,
    meta: {
      auth: true,
      title: 'Laporan Omzet SC | Kasir',
      layout: LayoutDefault,
      breadcrumb: 'Laporan Omzet SC',
    },
  },
  {
    path: root + '/log-pembayaran',
    component: LogPembayaran,
    meta: {
      auth: true,
      title: 'Log Pembayaran | Kasir',
      layout: LayoutDefault,
      breadcrumb: 'Log Pembayaran',
    },
  },
  {
    path: root + '/laporan/',
    component: LayoutData,
    children: [
      {
        path: '',
        component: Laporan,
        meta: {
          auth: true,
          title: 'Laporan | Kasir',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-laporan',
        component: TambahLaporan,
        meta: {
          auth: true,
          title: 'Tambah Faktur SC | Kasir',
          layout: LayoutDefault,
        },
      },
      {
        path: 'restock/',
        component: LayoutData,
        children: [
          {
            path: '',
            component: LaporanRestock,
            meta: {
              auth: true,
              title: 'Restock | Kasir',
              layout: LayoutDefault,
            },
          },
          {
            path: 'tambah-restock',
            component: TambahLaporanRestock,
            meta: {
              auth: true,
              title: 'Tambah Restock | Kasir',
              layout: LayoutDefault,
            },
          },
          {
            path: ':id',
            component: TambahLaporanRestock,
            meta: {
              auth: true,
              title: 'Edit Restock | Kasir',
              layout: LayoutDefault,
            },
          },
        ],
      },
    ],
  },
  {
    path: root + '/topup/',
    component: LayoutData,
    children: [
      {
        path: 'saldo-stockist/',
        component: LayoutData,
        children: [
          {
            path: '',
            component: TopupStockist,
            name: 'topup.saldo-stockist',
            meta: {
              auth: true,
              title: 'Topup Stockist | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Topup Saldo Stockist',
            },
          },
          {
            path: 'tambah',
            component: TambahTopupStockist,
            name: 'topup.saldo-stockist.tambah',
            meta: {
              auth: true,
              title: 'Tambah Saldo Stockist | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Tambah Saldo Stockist',
            },
          },
        ],
      },
      {
        path: 'saldo-restock-sc/',
        component: LayoutData,
        children: [
          {
            path: '',
            component: TopupSaldoRestockSc,
            name: 'kasir.topup.saldo-restock-sc',
            meta: {
              auth: true,
              title: 'Topup Saldo Restock SC | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Topup Saldo Saldo Restock SC',
            },
          },
          {
            path: 'tambah',
            component: TambahTopupSaldoRestockSc,
            name: 'kasir.topup.saldo-restock-sc.tambah',
            meta: {
              auth: true,
              title: 'Tambah Saldo Saldo Restock SC | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Tambah Saldo Saldo Restock SC',
            },
          },
        ],
      },
      {
        path: 'saldo-sisa-pembayaran-sc/',
        component: LayoutData,
        children: [
          {
            path: '',
            component: TopupSaldoSisaPembayaranSc,
            name: 'kasir.topup.saldo-sisa-pembayaran-sc',
            meta: {
              auth: true,
              title: 'Topup Saldo Sisa Pembayaran SC | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Topup Saldo Saldo Sisa Pembayaran SC',
            },
          },
          {
            path: 'tambah',
            component: TambahTopupSaldoSisaPembayaranSc,
            name: 'kasir.topup.saldo-sisa-pembayaran-sc.tambah',
            meta: {
              auth: true,
              title: 'Tambah Saldo Saldo Sisa Pembayaran SC | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Tambah Saldo Saldo Sisa Pembayaran SC',
            },
          },
        ],
      },
      {
        path: 'tarik-saldo-deposit-sc/',
        component: LayoutData,
        children: [
          {
            path: '',
            component: TarikSaldoDepositSc,
            name: 'kasir.tarik.saldo-deposit-sc',
            meta: {
              auth: true,
              title: 'Tarik Saldo Deposit SC | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Tarik Saldo Deposit SC',
            },
          },
          {
            path: 'tambah',
            component: TambahTarikSaldoDepositSc,
            name: 'kasir.tarik.saldo-deposit-sc.tambah',
            meta: {
              auth: true,
              title: 'Tambah Tarik Saldo Deposit SC | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Tambah Tarik Saldo Deposit SC',
            },
          },
        ],
      },
      {
        path: 'tarik-saldo-sisa-pembayaran-sc/',
        component: LayoutData,
        children: [
          {
            path: '',
            component: TarikSaldoSisaPembayaranSc,
            name: 'kasir.tarik.saldo-sisa-pembayaran-sc',
            meta: {
              auth: true,
              title: 'Tarik Saldo Sisa Pembayaran SC | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Tarik Saldo Sisa Pembayaran SC',
            },
          },
          {
            path: 'tambah',
            component: TambahTarikSaldoSisaPembayaranSc,
            name: 'kasir.tarik.saldo-sisa-pembayaran-sc.tambah',
            meta: {
              auth: true,
              title: 'Tambah Tarik Saldo Sisa Pembayaran SC | Kasir Pusat',
              layout: LayoutDefault,
              breadcrumb: 'Tambah Tarik Saldo Sisa Pembayaran SC',
            },
          },
        ],
      },
    ],
  },
];
